<template>
    <Loading v-if="loading"></Loading>
    <div v-else class="mt-5">
      <div
          v-if="tableTestsItems.length === 0"
          class="w-100 d-flex flex-column justify-center align-center"
      >
        <img
            style="width: 400px"
            :src="noTestImage"
            alt="noQuestionImage">
        <div class="text-h5">{{$t('gamification.no_tests')}}</div>
        <div class="text-h6 font-weight-light text-grey-darken-1">{{$t('gamification.no_tests_added')}}</div>
        <PrimaryButton
            @click="goToDetail('new')"
            class="mt-5"
        >
          {{$t('gamification.add_test')}}
        </PrimaryButton>
      </div>
      <div v-else>
        <v-data-table
            v-model="selectedItems"
            :headers="headers"
            :items="tableTestsItems"
            :loading-text="$t('gamification.loading')"
            show-select
            items-per-page="25"
        >
          <template v-slot:no-data>
            {{$t('gamification.no_data')}}
          </template>
          <template v-slot:item.actions="{item}">
            <div class="d-flex justify-center align-center ga-1">
              <v-btn @click="goToDetail(item.id)" color="grey-darken-3" variant="text" size="small" icon="edit" />
              <v-btn @click="attemptToDelete(item.id)" color="red-darken-2" variant="text" size="small" icon="delete" />
            </div>
          </template>
          <template v-slot:bottom>
            <div class="d-flex justify-lg-space-between align-center">
              <div v-if="selectedItems.length!==0">
                <v-btn small class="actionsDetails ml-5"
                       @click.stop="dialog = true"
                       :disabled="selectedItems.length === 0"
                >{{$t('gamification.delete')}}
                </v-btn>
              </div>
              <v-spacer />
              <v-data-table-footer />
            </div>
          </template>

        </v-data-table>
        <DeleteDialog :method="deleteTests" :dialog="dialog"
                      v-on:childToParent="updateDialog"></DeleteDialog>
      </div>

    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import DeleteDialog from "@/components/map/DeleteDialog";
import Loading from "@/components/Loading";
import PrimaryButton from "@/components/buttons/PrimaryButton.vue";
import NoSubjects from "@/assets/gamification/no_subjects.png";

export default {
    name: "Tests",

    components: {PrimaryButton, DeleteDialog, Loading},

    async mounted() {
        await this.fetchTestsBySubjectId(this.subjectId);
        this.loading = false
    },

    data() {
        return {
            selectedItems: [],
            dialog: false,
            headers: [
                { title: this.$t('gamification.test_name'), align: 'left', sortable: true, value: 'name', width: '45%'},
                { title: this.$t('gamification.question_count'), align: 'left', sortable: false, value: 'questionCount', width: '30%'},
                { title: this.$t('gamification.action'), align: 'center', sortable: false, value: 'actions', width: '25%'},
            ],
            noTestImage: NoSubjects,
            toDelete: null,
            loading: true
        }
    },

    computed: {
        ...mapGetters('Tests', ['getTests', 'getTestsBySubjectId', 'didLoadedTests']),

        tableTestsItems() {
            return this.getTestsBySubjectId.map(test => {
              return {
                ...test,
                questionCount: test.questions.length
              }
            });
        },

       subjectId(){
          return Number(this.$route.params.subjectId)
       }
    },

    methods: {
        ...mapActions('Tests', ['fetchAllTests', 'deleteTestById', 'fetchTestsBySubjectId']),

        goToDetail(testId) {
            this.$router.push({
                name: 'TestDetail',
                params: {testId: testId, subjectId: this.subjectId}
            });
        },
       async deleteTests() {
            for (const itemId of this.selectedItems){
              await this.deleteTestById(itemId)
            }
            if(this.toDelete){
              await this.deleteTestById(this.toDelete)
            }
            this.selectedItems = [];
            this.dialog = false;
            this.toDelete = null
        },
        attemptToDelete(id){
          this.toDelete = id
          this.dialog = true
        },

        updateDialog() {
            this.dialog = false;
            this.toDelete = null
        }
    }
}
</script>

<style scoped>

.actionsDetails {
    background: rgba(0, 0, 0, 0.45) !important;
    color: white !important;
}

</style>